// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessconflict/v1/app_entitlement_monitor_binding.proto" (package "c1.api.accessconflict.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { AppEntitlementView } from "../../app/v1/app_entitlement";
import { Any } from "../../../../google/protobuf/any";
import { AppEntitlementExpandMask } from "../../app/v1/app_entitlement";
/**
 * @generated from protobuf message c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsRequest
 */
export interface SearchAppEntitlementMonitorBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string monitor_id = 3;
     */
    monitorId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4;
     */
    entitlementGroup: EntitlementGroup;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef refs = 6;
     */
    refs: AppEntitlementMonitorBindingRef[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsResponse
 */
export interface SearchAppEntitlementMonitorBindingsResponse {
    /**
     * @generated from protobuf field: string next_page_token = 1;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.AppEntitlementMonitorBindingView list = 3;
     */
    list: AppEntitlementMonitorBindingView[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsRequest
 */
export interface ListAppEntitlementMonitorBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string monitor_id = 3;
     */
    monitorId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4;
     */
    entitlementGroup: EntitlementGroup;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsResponse
 */
export interface ListAppEntitlementMonitorBindingsResponse {
    /**
     * @generated from protobuf field: string next_page_token = 1;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 3;
     */
    list: AppEntitlementView[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.GetAppEntitlementMonitorBindingRequest
 */
export interface GetAppEntitlementMonitorBindingRequest {
    /**
     * @generated from protobuf field: string monitor_id = 1;
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4;
     */
    entitlementGroup: EntitlementGroup;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingRequest
 */
export interface DeleteAppEntitlementMonitorBindingRequest {
    /**
     * @generated from protobuf field: string monitor_id = 1;
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4;
     */
    entitlementGroup: EntitlementGroup;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingResponse
 */
export interface DeleteAppEntitlementMonitorBindingResponse {
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.UpdateAppEntitlementMonitorBindingRequest
 */
export interface UpdateAppEntitlementMonitorBindingRequest {
    /**
     * @generated from protobuf field: string monitor_id = 1;
     */
    monitorId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 2;
     */
    entitlementGroup: EntitlementGroup;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlements_to_add = 3;
     */
    entitlementsToAdd: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlements_to_remove = 4;
     */
    entitlementsToRemove: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.CreateAppEntitlementMonitorBindingRequest
 */
export interface CreateAppEntitlementMonitorBindingRequest {
    /**
     * @generated from protobuf field: string monitor_id = 1;
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4;
     */
    entitlementGroup: EntitlementGroup;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBinding
 */
export interface AppEntitlementMonitorBinding {
    /**
     * @generated from protobuf field: string monitor_id = 1;
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EntitlementGroup entitlement_group = 4;
     */
    entitlementGroup: EntitlementGroup;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBindingView
 */
export interface AppEntitlementMonitorBindingView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1;
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef ref = 2;
     */
    ref?: AppEntitlementMonitorBindingRef;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef
 */
export interface AppEntitlementMonitorBindingRef {
    /**
     * @generated from protobuf field: string monitor_id = 1;
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf enum c1.api.accessconflict.v1.EntitlementGroup
 */
export enum EntitlementGroup {
    /**
     * @generated from protobuf enum value: ENTITLEMENT_GROUP_UNSPECIFIED = 0;
     */
    ENTITLEMENT_GROUP_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ENTITLEMENT_GROUP_A = 1;
     */
    ENTITLEMENT_GROUP_A = 1,
    /**
     * @generated from protobuf enum value: ENTITLEMENT_GROUP_B = 2;
     */
    ENTITLEMENT_GROUP_B = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementMonitorBindingsRequest$Type extends MessageType<SearchAppEntitlementMonitorBindingsRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementMonitorBindingRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsRequest
 */
export const SearchAppEntitlementMonitorBindingsRequest = new SearchAppEntitlementMonitorBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementMonitorBindingsResponse$Type extends MessageType<SearchAppEntitlementMonitorBindingsResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsResponse", [
            { no: 1, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementMonitorBindingView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.SearchAppEntitlementMonitorBindingsResponse
 */
export const SearchAppEntitlementMonitorBindingsResponse = new SearchAppEntitlementMonitorBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementMonitorBindingsRequest$Type extends MessageType<ListAppEntitlementMonitorBindingsRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsRequest
 */
export const ListAppEntitlementMonitorBindingsRequest = new ListAppEntitlementMonitorBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementMonitorBindingsResponse$Type extends MessageType<ListAppEntitlementMonitorBindingsResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsResponse", [
            { no: 1, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ListAppEntitlementMonitorBindingsResponse
 */
export const ListAppEntitlementMonitorBindingsResponse = new ListAppEntitlementMonitorBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementMonitorBindingRequest$Type extends MessageType<GetAppEntitlementMonitorBindingRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.GetAppEntitlementMonitorBindingRequest", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.GetAppEntitlementMonitorBindingRequest
 */
export const GetAppEntitlementMonitorBindingRequest = new GetAppEntitlementMonitorBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementMonitorBindingRequest$Type extends MessageType<DeleteAppEntitlementMonitorBindingRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingRequest", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingRequest
 */
export const DeleteAppEntitlementMonitorBindingRequest = new DeleteAppEntitlementMonitorBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementMonitorBindingResponse$Type extends MessageType<DeleteAppEntitlementMonitorBindingResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.DeleteAppEntitlementMonitorBindingResponse
 */
export const DeleteAppEntitlementMonitorBindingResponse = new DeleteAppEntitlementMonitorBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppEntitlementMonitorBindingRequest$Type extends MessageType<UpdateAppEntitlementMonitorBindingRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.UpdateAppEntitlementMonitorBindingRequest", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] },
            { no: 3, name: "entitlements_to_add", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 4, name: "entitlements_to_remove", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.UpdateAppEntitlementMonitorBindingRequest
 */
export const UpdateAppEntitlementMonitorBindingRequest = new UpdateAppEntitlementMonitorBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppEntitlementMonitorBindingRequest$Type extends MessageType<CreateAppEntitlementMonitorBindingRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.CreateAppEntitlementMonitorBindingRequest", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.CreateAppEntitlementMonitorBindingRequest
 */
export const CreateAppEntitlementMonitorBindingRequest = new CreateAppEntitlementMonitorBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementMonitorBinding$Type extends MessageType<AppEntitlementMonitorBinding> {
    constructor() {
        super("c1.api.accessconflict.v1.AppEntitlementMonitorBinding", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "entitlement_group", kind: "enum", T: () => ["c1.api.accessconflict.v1.EntitlementGroup", EntitlementGroup] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBinding
 */
export const AppEntitlementMonitorBinding = new AppEntitlementMonitorBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementMonitorBindingView$Type extends MessageType<AppEntitlementMonitorBindingView> {
    constructor() {
        super("c1.api.accessconflict.v1.AppEntitlementMonitorBindingView", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "ref", kind: "message", T: () => AppEntitlementMonitorBindingRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBindingView
 */
export const AppEntitlementMonitorBindingView = new AppEntitlementMonitorBindingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementMonitorBindingRef$Type extends MessageType<AppEntitlementMonitorBindingRef> {
    constructor() {
        super("c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.AppEntitlementMonitorBindingRef
 */
export const AppEntitlementMonitorBindingRef = new AppEntitlementMonitorBindingRef$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AppEntitlementMonitorBindingService
 */
export const AppEntitlementMonitorBindingService = new ServiceType("c1.api.accessconflict.v1.AppEntitlementMonitorBindingService", [
    { name: "ListAppEntitlementMonitorBindings", options: { "authz.method": { role: "VIEWER" } }, I: ListAppEntitlementMonitorBindingsRequest, O: ListAppEntitlementMonitorBindingsResponse },
    { name: "GetAppEntitlementMonitorBinding", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/appentitlementmonitorbinding/get", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App_Entitlement_Monitor_Binding" }], group: "App Entitlement Monitor Binding" }] } }, I: GetAppEntitlementMonitorBindingRequest, O: AppEntitlementMonitorBinding },
    { name: "UpdateAppEntitlementMonitorBinding", options: { "authz.method": { role: "EDITOR" } }, I: UpdateAppEntitlementMonitorBindingRequest, O: Empty },
    { name: "DeleteAppEntitlementMonitorBinding", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/appentitlementmonitorbinding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App_Entitlement_Monitor_Binding" }], group: "App Entitlement Monitor Binding" }] } }, I: DeleteAppEntitlementMonitorBindingRequest, O: DeleteAppEntitlementMonitorBindingResponse },
    { name: "CreateAppEntitlementMonitorBinding", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/appentitlementmonitorbinding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App_Entitlement_Monitor_Binding" }], group: "App Entitlement Monitor Binding" }] } }, I: CreateAppEntitlementMonitorBindingRequest, O: AppEntitlementMonitorBinding }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AppEntitlementMonitorBindingSearchService
 */
export const AppEntitlementMonitorBindingSearchService = new ServiceType("c1.api.accessconflict.v1.AppEntitlementMonitorBindingSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementMonitorBindingsRequest, O: SearchAppEntitlementMonitorBindingsResponse }
]);
